'use strict';

import randomstring from 'just.randomstring';
import moment from 'moment';

export default function EditUserController($scope, $mdDialog, Auth, user, appConfig) {
  'ngInject';

  if(user.expiryDate) {
    user.expiryDate = new Date(user.expiryDate);
  }

  if(user.eventDate) {
    user.eventDate = new Date(user.eventDate);
  }

  $scope.user = user;
  $scope.submitted = false;
  $scope.layoutTypes = appConfig.layoutTypes;
  $scope.user.access = user.expiryDate ? 'temporary' : 'permanent';
  $scope.accessList = [{ name: 'permanent', title: 'dauerhaft' }, { name: 'temporary', title: 'temporär' }];

  $scope.$watch('user.access', function(newValue, oldValue) {
    if(newValue === 'temporary' && !$scope.user.expiryDate) {
      const newDefaultDateTime = moment();

      // Set the default time 23:59
      newDefaultDateTime.hour(23);
      newDefaultDateTime.minute(59);

      $scope.user.expiryDate = newDefaultDateTime.toDate();
    }
  });

  $scope.cancel = () => {
    $mdDialog.hide();
  };

  $scope.generatePassword = () => {
    const newPassword = randomstring(6);
    $scope.user.password = newPassword;
  };

  $scope.updateUser = () => {
    const data = $scope.user;

    this.submitted = true;

    if($scope.form.$valid) {
      let promises = [];

      if(data.password) {
        promises.push(Auth.changePassword(data._id, null, data.password));
      }

      promises.push(Auth.updateUser(data));

      Promise.all(promises)
        .then(() => {
          $mdDialog.hide();
        })
        .catch(err => {
          $mdDialog.hide();
        });
    }
  };
}



// WEBPACK FOOTER //
// ./client/app/admin/edit-user.controller.js